import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative text-primary-dark" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sm:flex sm:items-center pb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sm:flex-auto" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-base font-semibold text-primary-dark m-0" }, "Payment Gateway Logs"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-secondary" }, "A list of all the logs in your account")
  ])
], -1)
const _hoisted_3 = { class: "flex items-center gap-2 pb-2" }
const _hoisted_4 = { class: "mt-2 bg-gray-100 p-4 rounded-md overflow-auto max-h-96 transition-all" }
const _hoisted_5 = { class: "text-sm" }

import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';

import { PaymentGatewayLogsI, PaginationI } from '@/interfaces/interfaces';

import BaseInput from '@/components/inputs/BaseInput.vue';
import OverlaySpinner from "@/components/loader/OverlaySpinner.vue";
import BaseModal from '@/components/common/BaseModal.vue';
import LogsTable from '@/components/PaymentGatewayLogs/LogsTable.vue';
import LogsPagination from '@/components/PaymentGatewayLogs/LogsPagination.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentGatewayLogs',
  setup(__props) {

const store = useStore();

const isLoading = ref(false);
const logs = ref<PaymentGatewayLogsI[]>([]);
const pagination = ref<PaginationI>({
  lastPage: 0,
  page: 1,
  perPage: 0,
  total: 0,
});
const search = ref<{
  startDate: Date | null,
  amount: number | null,
  widgetName: string | null,
}>({
  startDate: null,
  amount: null,
  widgetName: null,
});
const showPayloadModal = ref(false);
const currentPayload = ref('');

onMounted(() => {
  getLogs();
})

const openPayloadModal = (payload: string) => {
  try {
    const parsedPayload = JSON.parse(payload);
    currentPayload.value = JSON.stringify(parsedPayload, null, 2);
    showPayloadModal.value = true;
  } catch (error) {
    console.error('Error parsing payload:', error);
    // Fallback to raw string if JSON parsing fails
    currentPayload.value = payload;
    showPayloadModal.value = true;
  }
};

const closePayloadModal = () => {
  showPayloadModal.value = false;
  currentPayload.value = '';
};

const getLogs = async (isPagination = false) => {
  isLoading.value = true;

  store
    .dispatch('getPaymentGatewayLogs',{
      page: isPagination ? pagination.value.page : null,
      startDate: search.value.startDate,
      amount: search.value.amount,
      widgetName: search.value.widgetName,
    })
    .then(() => {
      logs.value = store.state.paymentGatewayLogs?.data || [];
      pagination.value = store.state.paymentGatewayLogs?.pagination || {};
      isLoading.value = false;
    })
    .catch((error) => {
      console.error(error);
      isLoading.value = false;
    })
}

const handleSearch = () => {
  getLogs();
}

const handlePagination = (page: number) => {
  pagination.value.page = page;
  search.value.startDate = null;
  search.value.amount = null;
  search.value.widgetName = null;
  getLogs(true);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(BaseInput, {
        id: "startDate",
        type: "date",
        value: search.value.startDate,
        label: "Start Date",
        class: "min-w-[200px]",
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (search.value.startDate = $event))
      }, null, 8, ["value"]),
      _createVNode(BaseInput, {
        id: "amount",
        type: "number",
        value: search.value.amount,
        min: 0,
        label: "Amount",
        placeholder: "Search",
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (search.value.amount = $event))
      }, null, 8, ["value"]),
      _createVNode(BaseInput, {
        id: "widgetName",
        type: "text",
        value: search.value.widgetName,
        label: "Widget Name",
        placeholder: "Search",
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (search.value.widgetName = $event))
      }, null, 8, ["value"]),
      _createElementVNode("button", {
        type: "button",
        class: "btn-primary is-btn-size-default flex items-center gap-2",
        onClick: handleSearch
      }, " Search ")
    ]),
    _createVNode(LogsTable, {
      logs: logs.value,
      "onPayloadModal:open": openPayloadModal
    }, null, 8, ["logs"]),
    _createVNode(LogsPagination, {
      pagination: pagination.value,
      "onUpdate:page": handlePagination
    }, null, 8, ["pagination"]),
    (showPayloadModal.value)
      ? (_openBlock(), _createBlock(BaseModal, {
          key: 0,
          title: "Response Payload",
          onCancel: closePayloadModal
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("pre", _hoisted_5, _toDisplayString(currentPayload.value), 1)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (isLoading.value)
      ? (_openBlock(), _createBlock(OverlaySpinner, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})